<h2 mat-dialog-title class="modal-title"></h2>
<mat-dialog-content class="un-authorized">
    <div class="content">
        <p>You do not have required permissions, please contact your College Administrator.</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="btn-actions">
    <button type="button" class="btn btn-secondary" (click)="close()">OK</button>
</mat-dialog-actions>